export default function Thumbnail({
    value, side, className
}:{
    value: string,
    side: number,
    className?: string
}){
    return value?
    <img
        src = {value}
        alt = {""}
        height = {side}
        width = {side}
        className = {`rounded mr-2 ${className}`}
    />
    :
    <></>
}